// LOGOUT REASONS

export const EXPIRED_TOKEN = 'LOGOUT_REASON/EXPIRED_TOKEN';
export const FORCED_LOGOUT = 'LOGOUT_REASON/FORCED_LOGOUT';
export const USER_LOGOUT = 'LOGOUT_REASON/USER_LOGOUT';
